import { render, staticRenderFns } from "./ImportantOldPage.vue?vue&type=template&id=db500ce2&scoped=true&"
import script from "./ImportantOldPage.vue?vue&type=script&lang=ts&"
export * from "./ImportantOldPage.vue?vue&type=script&lang=ts&"
import style0 from "./ImportantOldPage.vue?vue&type=style&index=0&id=db500ce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db500ce2",
  null
  
)

export default component.exports